module.exports = __webpack_public_path__ + "images/common/logoMomentumWhite.050a05a6.svg";